import { render, staticRenderFns } from "./ProfileNav.vue?vue&type=template&id=c5755fce&lang=pug&"
import script from "./ProfileNav.vue?vue&type=script&lang=js&"
export * from "./ProfileNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports